import React, { useRef } from "react";
import RecentBallResults from "../components/RecentBallResults";
import LiveBattingTable from "../components/LiveBattingTable";
import TeamScores from "../components/TeamScores";
import "./EcricStream.scss";
import ReactPlayer from "react-player";

// const parentDomains = [
//   'www.indibet.com', 
//   'indibet.com', 
//   'indibetsportsbook.com', 
//   'www.indibetsportsbook.com',
//   'www.indibetstage.com', 
//   'indibetstage.com', 
//   'indibetsportsbookstage.com',
//   'www.indibetsportsbookstage.com',
//   'www.ib91.in',
//   'ib91.in',
//   'www.salad6688.com',
//   'salad6688.com',
//   'www.decimalcricket.net',
//   'decimalcricket.net',
//   'staging.decimalcricket.net',
//   'widget-staging.decimalcricket.net',
//   'www.intelligentcricket.com',
//   'intelligentcricket.com',
//   'staging.intelligentcricket.com',
//   'www.orbitestnd.com',
//   'orbitestnd.com',
//   'www.bfb247stage.com',
//   'bfb247stage.com',
//   'pb77stage.co',
//   'all.testjj9.com',
//   'www.orbitxch.com',
//   'orbitxch.com',
//   'www.indi.club',
//   'indi.club',
//   'www.indibet.in',
//   'indibet.in',
//   'www.indi.bet',
//   'indi.bet',
//   'www.indijeeto.com',
//   'indijeeto.com',
//   'www.indi100.com',
//   'indi100.com',
//   'www.bfb247.com',
//   'bfb247.com',
//   'www.pb77.co',
//   'pb77.co',
//   'www.96in.com',
//   '96in.com',
//   'www.tc20003.com',
//   'tc20003.com'
// ]

const Clip = ({ stream_url, domains }) => {
  const videoRef = useRef(null);

  return (
    <div className="clip">
      <ReactPlayer
        url={stream_url}
        controls={true}
        muted={true}
        playing={true}
        ref={videoRef}
        width="100%"
        height="100%"
        config={{
          twitch: {
            options: {
              parent: domains
            }
          },
        }}
      />
    </div>
  );
};

export default function EcricStream({
  layout,
  teams,
  event,
  scorecard,
  scoregrid,
  scoreboard,
  backgroundColor,
  gameType,
  fullscreenCartoon,
  domains,
  channel,
  isECN
}) {
  //Get stream url from event scoreboard
  const stream_url = event.scoreboard.find(
    (element) => element.name === "stream_url"
  ).value;

  if (!scorecard && gameType !== "KABD") {
    return null;
  }

  const { overs } = scoregrid || {};

  const { inns1, inns2, inns3, inns4 } = overs || {};

  let recentOvers = [];

  if (inns1) {
    inns1.forEach((over) => {
      let balls = [];

      for (let i = 1; i <= 12; i++) {
        if (over["b" + i]) {
          balls.unshift(over["b" + i]);
        }
      }

      recentOvers.unshift({
        over: over.ov,
        balls,
      });
    });
  }

  if (inns2) {
    inns2.forEach((over) => {
      let balls = [];

      for (let i = 1; i <= 12; i++) {
        if (over["b" + i]) {
          balls.unshift(over["b" + i]);
        }
      }

      recentOvers.unshift({
        over: over.ov,
        balls,
      });
    });
  }

  if (inns3) {
    inns3.forEach((over) => {
      let balls = [];

      for (let i = 1; i <= 12; i++) {
        if (over["b" + i]) {
          balls.unshift(over["b" + i]);
        }
      }

      recentOvers.unshift({
        over: over.ov,
        balls,
      });
    });
  }

  if (inns4) {
    inns4.forEach((over) => {
      let balls = [];

      for (let i = 1; i <= 12; i++) {
        if (over["b" + i]) {
          balls.unshift(over["b" + i]);
        }
      }

      recentOvers.unshift({
        over: over.ov,
        balls,
      });
    });
  }

  function getStreamUrl() {
    if (channel === 1) return "https://ic-lowlatency.s3.eu-west-2.amazonaws.com/widgetVideo.html?channel=1"
    if (channel === 2) return "https://ic-lowlatency.s3.eu-west-2.amazonaws.com/widgetVideo.html?channel=2"
    if (channel === 3) return "https://ic-lowlatency.s3.eu-west-2.amazonaws.com/widgetVideo.html?channel=3"
    if (channel === 4) return "https://ic-lowlatency.s3.eu-west-2.amazonaws.com/widgetVideo.html?channel=4"
    if (channel === 5) return "https://ic-lowlatency.s3.eu-west-2.amazonaws.com/widgetVideo.html?channel=5"
    if (channel === 6) return "https://ic-lowlatency.s3.eu-west-2.amazonaws.com/widgetVideo.html?channel=6"
    if (channel === 7) return "https://ic-lowlatency.s3.eu-west-2.amazonaws.com/widgetVideo.html?channel=7"
    if (channel === 8) return "https://ic-lowlatency.s3.eu-west-2.amazonaws.com/widgetVideo.html?channel=8"
    if (channel === 9) return "https://ic-lowlatency.s3.eu-west-2.amazonaws.com/widgetVideo.html?channel=9"
    if (channel === 10) return "https://ic-lowlatency.s3.eu-west-2.amazonaws.com/widgetVideo.html?channel=10"
    if (channel === 11) return "https://ic-lowlatency.s3.eu-west-2.amazonaws.com/widgetVideo.html?channel=11"
    if (channel === 12) return "https://ic-lowlatency.s3.eu-west-2.amazonaws.com/widgetVideo.html?channel=12"
  }

  return (
    <div
      className="cartoons"
      style={{
        backgroundColor,
        display: layout === "double" ? "flex" : "block",
      }}
    >
      {layout === "single" && ! fullscreenCartoon && (
        <>
          <TeamScores teams={teams} event={event} scoreboard={scoreboard} />
          <LiveBattingTable scoreboard={scoreboard} />
        </>
      )}
      {isECN ? (
                <iframe 
                    title="stream-iframe"
                    src={getStreamUrl()}
                    style={{
                        width: "95%",
                        height: "56%",
                        position: "absolute",
                        left: "50%",
                        transform: "translateX(-50%)"
                    }}
                    >

                </iframe>

            
        ) :
      (<div
        className="video-wrapper"
        style={{
          display: layout === "double" ? "flex" : "block",
        }}
      >
        <Clip stream_url={stream_url} domains={domains}/>
        {layout === "single" && ! fullscreenCartoon && <RecentBallResults scoregrid={scoregrid} />}
      </div>)}
    </div>
  );
}
